import $ from "jquery";
import React, { Component } from "react";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class Sorters extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        var sid = Context.GetContext().Sid;

        var sorters = Comm.Sorters(sid);

        this.state = {
            Sorters: sorters,
            SelectedSorter: null,
            showMissingNameError: false,
        };

        this.EditSorter = this.EditSorter.bind(this);
        this.NewSorter = this.NewSorter.bind(this);
        this.Save = this.Save.bind(this);
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        var sorters = this.state.Sorters.slice();

        var self = this;

        return Context.HasRight("rsorters") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("sorters")}</div>
                <div className="panel-body">
                    {Context.HasRight("esorters") ? (
                        <button className="btn btn-primary" onClick={this.NewSorter}>
                            {Translation.Trans("newsorter")}
                        </button>
                    ) : null}
                    <br />
                    <br />
                    <br />
                    <div className="row">
                        <div className="col-md-5">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th width="90%">{Translation.Trans("name")}</th>
                                        <th width="10%"></th>
                                    </tr>
                                </thead>
                            </table>
                            <div className="scrollableDiv">
                                <table className="table table-striped">
                                    <tbody>
                                        {sorters.map((obj) =>
                                            true ? (
                                                <tr>
                                                    <td width="90%">
                                                        <span
                                                            className={
                                                                this.state.SelectedSorter != null &&
                                                                    this.state.SelectedSorter.id === obj.id
                                                                    ? "btn btn-warning"
                                                                    : null
                                                            }
                                                        >
                                                            <a
                                                                onClick={() => self.EditSorter(obj)}
                                                                className="pointhand"
                                                            >
                                                                {obj.name}
                                                            </a>
                                                        </span>
                                                    </td>
                                                </tr>
                                            ) : null
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {this.state.SelectedSorter !== null ? (
                            <div className="col-md-7 borderDiv">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label className="control-label">{Translation.Trans("name")}</label>
                                    </div>
                                    <div className="col-md-9">
                                        <input
                                            type="text"
                                            id="tbName"
                                            className="form-control"
                                            defaultValue={this.state.SelectedSorter.name}
                                            key={"name" + this.state.SelectedSorter.id}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.showMissingNameError ? (
                                            <div className="alert alert-danger">
                                                {Translation.Trans("entervalue")}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <label className="control-label">
                                            {Translation.Trans("barcodename")}
                                        </label>
                                    </div>
                                    <div className="col-md-9">
                                        <input
                                            type="text"
                                            id="tbBarcodeName"
                                            className="form-control"
                                            defaultValue={this.state.SelectedSorter.label_name}
                                            key={"barcodename" + this.state.SelectedSorter.id}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <label className="control-label">
                                            {Translation.Trans("visible")}
                                        </label>
                                    </div>
                                    <div className="col-md-9">
                                        <div className="checkbox">
                                            <input
                                                id="cbVisible"
                                                type="checkbox"
                                                defaultChecked={this.state.SelectedSorter.visible}
                                                key={"input" + this.state.SelectedSorter.id}
                                            />
                                            <label htmlFor="cbVisible"></label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    {Context.HasRight("esorters") ? (
                                        <div className="col-md-12">
                                            <button
                                                className="btn btn-primary pull-right"
                                                onClick={this.Save}
                                            >
                                                {Translation.Trans("save")}
                                            </button>
                                            <button
                                                className="btn btn-info pull-right"
                                                onClick={() => self.Del()}
                                            >
                                                <i className="fa fa-trash" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }

    EditSorter(sorter) {
        this.setState({ SelectedSorter: sorter });
    }
    NewSorter() {
        this.setState({ SelectedSorter: { visible: true } });
    }

    Save() {
        this.setState({ showMissingNameError: false });
        var canSave = true;
        var name = $("#tbName").val();
        var barcodename = $("#tbBarcodeName").val();
        var visible = $("#cbVisible").prop("checked");

        if (name === "") {
            this.setState({ showMissingNameError: true });
            canSave = false;
        }

        if (!canSave) return;

        var data = {};
        if (this.state.SelectedSorter.hasOwnProperty("id")) {
            data.id = this.state.SelectedSorter.id;
        }
        data.name = name;
        data.label_name = barcodename;
        data.visible = visible;
        var sid = Context.GetContext().Sid;

        var postdata = {
            sorter: JSON.stringify(data),
            session: sid,
        };
        Comm.SaveSorter(postdata);

        var sorters = Comm.Sorters(sid);

        this.setState({
            Sorters: sorters,
            SelectedSorter: null,
            showMissingNameError: false,
        });
    }

    Del() {
        if (window.confirm(Translation.Trans("pleaseconfirm"))) {
            var data = this.state.SelectedSorter;
            var sid = Context.GetContext().Sid;
            data.session = sid;
            data.visible = false;
            Comm.SaveSorter(data);
            this.setState({ SelectedSorter: null });
        }


        //павката не ми го е дал
    }
}

export default Sorters;



// WEBPACK FOOTER //
// ./src/pages/sorters.js